import { qs } from 'music';
import 'music/app/javascript/src/custom_elements/index.js';
import 'music/app/javascript/src/v3/custom_elements/index.js';
import 'music/app/javascript/src/v3/styles/index.scss';
/* UA shared */
import '~/src/shared_ui/custom_elements/index.js';
import '~/src/shared_ui/styles/index.scss';
import initializeTermsOfUseModal from '~/src/features/shared/initialize_terms_of_use_modal.js';

window.addEventListener('DOMContentLoaded', () => {
  initializeTermsOfUseModal();
  /** Opens TOS dialog when view is rendered */
  qs('.tos-dialog').show();
});
